import React, { useState } from "react";
import TextInput from "../../../../components/TextInput";
import { toast } from "../../../../components/toastNotification";
import Button from "../../../../components/Button";
import { CheckCircleIcon, XCircleIcon } from "@heroicons/react/24/solid";
import ConfirmBoxModal from "../../../../components/ConfirmBoxModal";
import useAddEmployeeStatus from "./hooks/useAddEmployeeStatus";
import useEmployeeStatus from "./hooks/useEmployeeStatus";
import { useRecoilState } from "recoil";
import MaterialExTable from "../../../../components/tables/MaterialExTable";

import {
  addStateEmployeeStatus,
  setFilterTextEmployeeStatus,
} from "./atoms/atoms";

import CheckBoxHookForm from "components/CheckBoxHookForm";

const EmployeeStatusForm = () => {
  //Hooks
  const AddEmployeeStatus = useAddEmployeeStatus();
  const { data } = useEmployeeStatus();
  //Recoils Call
  const [actionAddState, setActionAddState] = useRecoilState(
    addStateEmployeeStatus
  );
  const [_, setFilterText] = useRecoilState(
    setFilterTextEmployeeStatus
  );
  const [changed, setChanged] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [hasEmployeeStatus, setHasEmployeeStatus] = useState(false);

  const defaulValues = {
    employeeStatusId: 0,
    employeeStatusName: "",
    createdBy: "",
    createdOn: null,
    updatedBy: null,
    updatedOn: null,
    isActive: 0,
    usedInMexico: 0,
  };
  const [empStatusNewData] = useState([defaulValues]);
  const [employeeStatusExist, setemployeeStatusExist] = useState(false);

  const handleAddEmployeeStatus = (SourceType, fieldName, inputValue, rowData) => {
    if (SourceType !== "addEmployeeStatus") return;

    setChanged(true);
    setemployeeStatusExist(false);

    if (fieldName === "employeeStatusName") {
      const trimmedInput = inputValue.trim().toUpperCase();
      const nameMatch = data.find(
        (item) =>
          item.employeeStatusName?.toUpperCase() === trimmedInput &&
          item.usedInMexico === rowData?.usedInMexico
      );

      if (nameMatch) {
        setemployeeStatusExist(true);
      } else {
        empStatusNewData.forEach((x) => {
          x.employeeStatusName = inputValue.trim();
        });
      }

      setHasEmployeeStatus(trimmedInput !== "");
    }

    if (fieldName === "employeeStatusIsMexico") {
      const existingEntry = data.find(
        (item) =>
          item.employeeStatusName?.toUpperCase() ===
          rowData?.employeeStatusName?.trim().toUpperCase() &&
          item.usedInMexico === inputValue
      );

      if (existingEntry) {
        setemployeeStatusExist(true);
      }

      empStatusNewData.forEach((x) => {
        x.usedInMexico = inputValue;
      });
    }
  };

  //save changes
  const handleSave = (empStatusNewData) => {
    if (changed) {
      if (!employeeStatusExist) {
        if (empStatusNewData.filter((x) => x.employeeStatusName) !== "") {
          //call Insert
          AddEmployeeStatus(empStatusNewData);
          setActionAddState(!actionAddState);
          setOpenModal(false);
        } else {
          toast.fire(
            "Saving Failed",
            "All required fields must be filled!",
            "error"
          );
          setOpenModal(false);
        }
      } else {
        toast.fire("Saving Failed", "Employee Status already exists!", "error");
        setOpenModal(false);
      }
    } else {
      toast.fire("Saving Failed", "No Changes have been made", "warning");
      setOpenModal(false);
    }
  };
  // end of saving changes

  const matcolumns = [
    {
      title: "Employee Status Name",
      field: "employeeStatusName",
      render: (rowData) => {
        return (
          <div className="grid-cols-2 grid ">
            <TextInput
              defaultValue={rowData.employeeStatusName}
              onChange={(e) =>
                handleAddEmployeeStatus(
                  "addEmployeeStatus",
                  "employeeStatusName",
                  e.target.value
                )
              }
            />
          </div>
        );
      },
    },
    {
      title: "Is Mexico",
      render: (rowData) => {
        return (
          <CheckBoxHookForm
            checked={rowData.usedInMexico === true ? true : false}
            onClick={(e) => {
              handleAddEmployeeStatus(
                "addEmployeeStatus",
                "employeeStatusIsMexico",
                !rowData.usedInMexico
              )
            }}
            register={() => { }}
          />
        )
      }
    },
  ];
  return (
    <div className="">
      <div className="w-full ">
        <ConfirmBoxModal
          ModalTitle="Add Employee Status"
          qConfirmation=" Are you sure you want to add this?"
          isOpen={openModal}
          onClose={() => setOpenModal(false)}
          onClickFunction={() => {
            handleSave(empStatusNewData);
          }}
        />
        <div className=" px-3 border-l-2  border-primary box-shadow">
          <div className="flex items-center justify-between">
            <div className="text-base text-primary font-bold">
              Add New Employee Status
            </div>
            <div className="flex items-center space-x-2 pt-2 pb-2">
              <Button
                className={`flex items-center shadow-md text-xs font-semibold text-white justify-left gap-x-1 rounded-full bg-senary hover:bg-senary px-3 py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-senary focus:ring-opacity-70
              ${!hasEmployeeStatus ? "opacity-50" : "opactiy-100"}`}
                disabled={!hasEmployeeStatus}
                onClickFunction={() => setOpenModal(true)}
              >
                <CheckCircleIcon className="h-4 w-4" />
                <div className="text-xs3 font-normal self-center -mt-px">
                  Save
                </div>
              </Button>
              <Button
                className="flex items-center text-xs shadow-md font-semibold text-white justify-left gap-x-1 rounded-full bg-octonary hover:bg-octonary px-2 py-1 "
                onClickFunction={() => {
                  setActionAddState(!actionAddState);
                  setFilterText("");
                }}
              >
                <XCircleIcon className="h-4 w-4" />
                <div className="text-xs3 font-normal self-center -mt-px">
                  Cancel
                </div>
              </Button>
            </div>
          </div>

          <div className=" h-0.5 w-full border-b-2 border-secondary "></div>

          {/* <div className="py-3"></div> */}

          <div className=" w-full py-2  ">
            <MaterialExTable
              columns={matcolumns}
              data={empStatusNewData}
              paging={false}
            />
          </div>
        </div>
        <div className="hidden sm:block" aria-hidden="true">
          <div className="py-1"></div>
        </div>
      </div>
    </div>
  );
};

export default EmployeeStatusForm;
